// extracted by mini-css-extract-plugin
module.exports = {"scrollbar-hide":"container_scrollbar-hide__C8V2y"};